import React from 'react';
import PrivacyTipRoundedIcon from '@mui/icons-material/PrivacyTipRounded';
import StorageRoundedIcon from '@mui/icons-material/StorageRounded';
import ShareRoundedIcon from '@mui/icons-material/ShareRounded';
import CookieRoundedIcon from '@mui/icons-material/CookieRounded';
import SecurityUpdateGoodRoundedIcon from '@mui/icons-material/SecurityUpdateGoodRounded';
import InfoPageLayout from './components/InfoPageLayout';
import InfoSection from './components/InfoSection';
import './InfoPage.scss';

const Privacy = () => (
    <InfoPageLayout
        eyebrow="Your data"
        title="Privacy Policy"
        subtitle="We take your privacy seriously. Here's how Khaata POS collects, uses, and protects your information."
    >
        <InfoSection icon={<PrivacyTipRoundedIcon />} title="Overview">
            <p>
                At Khaata POS, we take your privacy seriously. This policy outlines how we collect, use,
                and protect your personal and business information when you use our point-of-sale system.
            </p>
        </InfoSection>

        <InfoSection icon={<StorageRoundedIcon />} title="Information we collect">
            <ul className="info-list">
                <li className="info-list__item">
                    <span className="info-list__label">Business information</span>
                    <p className="info-list__text">
                        Name, address, contact details, tax information, and business registration details.
                    </p>
                </li>
                <li className="info-list__item">
                    <span className="info-list__label">Transaction data</span>
                    <p className="info-list__text">
                        Sales records, inventory data, customer orders, and payment information.
                    </p>
                </li>
                <li className="info-list__item">
                    <span className="info-list__label">User data</span>
                    <p className="info-list__text">
                        Employee accounts, login credentials, and usage patterns.
                    </p>
                </li>
            </ul>
        </InfoSection>

        <InfoSection icon={<ShareRoundedIcon />} title="How we use your information">
            <ul className="info-list">
                <li className="info-list__item">
                    <span className="info-list__label">Service provision</span>
                    <p className="info-list__text">
                        To provide and maintain our POS services, including processing transactions and managing inventory.
                    </p>
                </li>
                <li className="info-list__item">
                    <span className="info-list__label">System improvements</span>
                    <p className="info-list__text">
                        To analyze usage patterns and improve our system's functionality and user experience.
                    </p>
                </li>
                <li className="info-list__item">
                    <span className="info-list__label">Support services</span>
                    <p className="info-list__text">
                        To provide technical support and respond to your inquiries.
                    </p>
                </li>
            </ul>
        </InfoSection>

        <InfoSection icon={<CookieRoundedIcon />} title="Cookies and tracking">
            <p>
                We use cookies and similar tracking technologies to enhance your experience with our system.
                These tools help us understand usage patterns and maintain security features.
            </p>
        </InfoSection>

        <InfoSection icon={<SecurityUpdateGoodRoundedIcon />} title="Updates to this policy" lastUpdated="February 2024">
            <p>
                We may update this privacy policy from time to time. We will notify you of any changes by
                posting the new policy on this page and updating the "Last updated" date.
            </p>
        </InfoSection>
    </InfoPageLayout>
);

export default Privacy;
